export default "__VITE_ASSET__0ff0f593__"